import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  header: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 6,
    [theme.breakpoints.down('sm')]: {
      margin: 0
    }
  },
  mianDiv: {
    // Sized to the parent, not the viewport: the negative margins pull the list 66px
    // into <main>'s padding on each side. A 100vw width only fit while the drawer was
    // collapsed and overflowed <main> by the drawer's extra width once it opened.
    // The 66px overhang must stay below <main>'s horizontal padding at >= sm
    // (theme.spacing(12) = 96px in mainDrawer/styles) or it reaches <main>'s edge.
    width: 'calc(100% + 132px)',
    marginLeft: -66,
    marginRight: -66,
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      margin: 0,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'center'
    }
  },
  exportButton: {
    background: theme.palette.grey[200],
    height: 35,
    boxShadow: 'none',
    '& span': {
      color: theme.palette.primary.main,
      [theme.breakpoints.down('sm')]: {
        fontSize: 10,
        '& svg': {
          fontSize: '15px !important'
        }
      }
    },
    [theme.breakpoints.down('sm')]: {
      marginRight: 0,
      marginTop: 2,
      height: '100%'
    }
  },
  buttonContainer: {
    display: 'flex',
    gap: 15
  },
  startIcon: {
    marginRight: -4
  }
}))

export default useStyles
